export interface TrustSignal {
  icon: string;
  title: string;
}

export const trustSignals: TrustSignal[] = [
  { icon: 'ri-file-text-line', title: 'Structured Educational Content' },
  { icon: 'ri-search-eye-line', title: 'SEO-Optimized Knowledge Base' },
  { icon: 'ri-guide-line', title: 'Step-by-Step Spreadsheet Guides' },
  { icon: 'ri-bar-chart-grouped-line', title: 'Comparison-Based Analysis Format' },
  { icon: 'ri-stack-line', title: 'Regular Content Expansion System' },
];

export const platformSignals: TrustSignal[] = [
  { icon: 'ri-table-line', title: 'Data-driven comparison tables across all guides' },
  { icon: 'ri-brain-line', title: 'Consistent Mulebuy spreadsheet terminology usage' },
  { icon: 'ri-link-m', title: 'Internal linking content cluster system' },
  { icon: 'ri-article-line', title: 'Long-form educational article structure' },
  { icon: 'ri-layout-line', title: 'Standardized content formatting across pages' },
];

export interface ArticleLink {
  title: string;
  path: string;
  description: string;
}

export const articleLinks: ArticleLink[] = [
  {
    title: 'Complete Mulebuy Spreadsheet Guide',
    path: '/mulebuy-spreadsheet-guide',
    description: 'A comprehensive walkthrough of the Mulebuy spreadsheet system — from setup to advanced optimization techniques for product sourcing.',
  },
  {
    title: 'Mulebuy Spreadsheet Workflow Tips',
    path: '/mulebuy-spreadsheet-workflow',
    description: 'Proven workflow strategies to maximize efficiency with your Mulebuy spreadsheet. Learn how top users organize their sourcing pipeline.',
  },
  {
    title: 'Mulebuy Spreadsheet Comparison Methods',
    path: '/mulebuy-spreadsheet-comparison',
    description: 'Master the art of product comparison using the Mulebuy spreadsheet framework. Includes pricing analysis, supplier scoring, and trend tracking.',
  },
  {
    title: 'Getting Started with Mulebuy Spreadsheet Setup',
    path: '/mulebuy-spreadsheet-setup',
    description: 'Step-by-step instructions for setting up your first Mulebuy spreadsheet. Learn column structures, data import methods, and initial configuration best practices.',
  },
  {
    title: 'Understanding Mulebuy Spreadsheet Category System',
    path: '/mulebuy-spreadsheet-categories',
    description: 'Deep dive into the category organization framework. Discover how to structure product categories for maximum filtering and comparison efficiency.',
  },
  {
    title: 'Mulebuy Spreadsheet Pricing Analysis Guide',
    path: '/mulebuy-spreadsheet-pricing',
    description: 'Advanced pricing analysis techniques using your Mulebuy spreadsheet. Track price trends, calculate margins, and identify the best supplier deals.',
  },
  {
    title: 'Product Tracking with Mulebuy Spreadsheet',
    path: '/mulebuy-spreadsheet-tracking',
    description: 'Comprehensive product tracking strategies. Monitor inventory levels, order statuses, and delivery timelines all within your spreadsheet system.',
  },
  {
    title: 'Sourcing Strategies Using Mulebuy Spreadsheet',
    path: '/mulebuy-spreadsheet-sourcing',
    description: 'Expert sourcing methodologies powered by spreadsheet data. Find reliable suppliers, evaluate product quality, and build a resilient supply chain.',
  },
  {
    title: 'Mulebuy Spreadsheet Templates Collection',
    path: '/mulebuy-spreadsheet-templates',
    description: 'Free downloadable Mulebuy spreadsheet templates for every category. Pre-built column structures ready for your product data — just import and start organizing.',
  },
  {
    title: 'Automating Your Mulebuy Spreadsheet Workflow',
    path: '/mulebuy-spreadsheet-automation',
    description: 'Semi-automation techniques to speed up your spreadsheet workflow. Conditional formatting, formula shortcuts, and data validation hacks for power users.',
  },
  {
    title: 'Mulebuy Spreadsheet Best Practices 2025',
    path: '/mulebuy-spreadsheet-best-practices',
    description: 'Updated best practices for spreadsheet-based product management. Industry-tested approaches that keep your sourcing operation running smoothly.',
  },
  {
    title: 'Mulebuy Spreadsheet FAQ & Troubleshooting',
    path: '/mulebuy-spreadsheet-faq',
    description: 'Common questions and solutions for Mulebuy spreadsheet users. Quick fixes for formatting issues, comparison errors, and organization challenges.',
  },
];